/**
 * 全站外壳：顶部滚动公告 + 标题 + 内容区 + 底部页签（对齐参考截图的移动端布局）。
 *
 * 首页（/）不渲染顶部标题：第一屏整块交给展示区（背景 + 立绘 + 站名，站名取自 settings.profile，
 * 不是写死的）；滚动公告在首页跟着页面走（不吸顶，免得压住立绘），其它页面吸顶常驻。
 * 成人模式提示由 PlatformNotices 在各个页面内容区里显示。
 */
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { usePlatform } from "../lib/bootstrap.tsx";
import { PlatformNotices } from "./PlatformNotices.tsx";

const TABS: { to: string; label: string; icon: string }[] = [
  { to: "/", label: "主页", icon: "🏠" },
  { to: "/g/tribute-cards", label: "抽卡", icon: "🎴" },
  { to: "/g/aeroplane-chess", label: "飞行棋", icon: "🛩️" },
  { to: "/admin", label: "后台", icon: "⚙️" },
  { to: "/account", label: "我的", icon: "🙂" },
];

/** 顶部滚动公告条：文案来自后台，关闭 announcementEnabled 或文案为空就整条不渲染 */
function Marquee({ text, sticky }: { text: string; sticky: boolean }) {
  return (
    <div className={`marquee ${sticky ? "marquee-sticky" : ""}`} role="note" aria-label="站点公告" data-testid="site-marquee">
      <span className="marquee-icon" aria-hidden="true">
        📢
      </span>
      <div className="marquee-viewport">
        <div className="marquee-track">
          <span className="marquee-item">{text}</span>
          {/* 复制一份接在后面，滚动到 -50% 时正好衔接，看不出接缝 */}
          <span className="marquee-item" aria-hidden="true">
            {text}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function Layout() {
  const { settings } = usePlatform();
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const { siteName, tagline } = settings.profile;
  const announcement = settings.announcementEnabled ? settings.announcement.trim() : "";

  return (
    <div className={isHome ? "app-shell-bare" : "app-shell"}>
      {announcement ? <Marquee text={announcement} sticky={!isHome} /> : null}

      {isHome ? null : (
        <>
          <header className="pt-6 pb-3 text-center">
            <h1 className="neon-title text-3xl">{siteName}</h1>
            {tagline[0] ? <p className="mt-2 text-xs text-cream-dim">{tagline[0]}</p> : null}
          </header>
          <PlatformNotices />
        </>
      )}

      <main className="flex-1">
        <Outlet />
      </main>

      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-line/80 bg-void/95 backdrop-blur">
        <div className="mx-auto flex w-full max-w-[860px]">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === "/" || tab.to === "/admin"}
              className={({ isActive }) => `tabbar-item ${isActive ? "tabbar-item-active" : ""}`}
            >
              <span className="text-lg leading-none">{tab.icon}</span>
              {tab.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
